import { gql } from "@apollo/client/core";
const ProductQuery = gql`
  query ($id: String!) {
    product(id: $id) {
      id
      name
      inStock
      gallery
      attributes {
        id
        name
        type
        items {
          displayValue
          value
        }
      }
      prices {
        currency {
          label
          symbol
        }
        amount
      }
      brand
      description
    }
  }
`;
export default ProductQuery;
